import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'

export type EditFormState = {
  recentSituation: string
  nextCheckPoints: string
  longTermTrend: string
}

interface EditSummaryDialogProps {
  open: boolean
  editForm: EditFormState
  saving: boolean
  onClose: () => void
  onSave: () => void
  onFormChange: (form: EditFormState) => void
}

/**
 * サマリ編集ダイアログ
 */
export function EditSummaryDialog({
  open,
  editForm,
  saving,
  onClose,
  onSave,
  onFormChange,
}: EditSummaryDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>サマリを編集</DialogTitle>
      <DialogContent>
        <TextField
          label="直近の状況"
          fullWidth
          multiline
          rows={3}
          value={editForm.recentSituation}
          onChange={(e) =>
            onFormChange({
              ...editForm,
              recentSituation: e.target.value,
            })
          }
          sx={{ mt: 2 }}
        />
        <TextField
          label="次回確認すること"
          fullWidth
          multiline
          rows={3}
          value={editForm.nextCheckPoints}
          onChange={(e) =>
            onFormChange({
              ...editForm,
              nextCheckPoints: e.target.value,
            })
          }
          sx={{ mt: 2 }}
        />
        <TextField
          label="長期傾向"
          fullWidth
          multiline
          rows={4}
          value={editForm.longTermTrend}
          onChange={(e) =>
            onFormChange({
              ...editForm,
              longTermTrend: e.target.value,
            })
          }
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          キャンセル
        </Button>
        <Button onClick={onSave} variant="contained" disabled={saving}>
          保存
        </Button>
      </DialogActions>
    </Dialog>
  )
}
